import { useMount } from '@apia/util';
import { useState } from 'react';
import { TSelectProps, TOption } from '../../components';
import { ValidatedCollectorField } from '../ValidatedCollectorField';
import { Select } from '../../components';
import { TValidationFunction, TValidationRules } from '../../types';

export class CollectorSelect extends ValidatedCollectorField<
  string,
  Omit<TSelectProps, 'name'>
> {
  type = 'select';

  constructor(
    protected _name: string,
    protected label: string,
    config?: Partial<{
      initialValue: string;
      options: TOption[];
      properties: Partial<Omit<TSelectProps, 'name'>>;
      validationFunction: TValidationFunction<string>;
      validationRules: TValidationRules;
    }>,
  ) {
    super(_name, label, config);
    if (config?.options) {
      this.#options = config.options;
    }
  }
  #options: TOption[] = [];

  addOption = (newOption: TOption) => {
    this.#options = [...this.#options, newOption];
    this.emit('optionsUpdate', this.#options);
  };

  setOptions = (newOptions: TOption[]) => {
    this.#options = [...newOptions];
    this.emit('optionsUpdate', this.#options);
  };

  #useOptions = () => {
    const [options, setOptions] = useState(this.#options);

    useMount(() => {
      return this.on('optionsUpdate', setOptions);
    });

    return options;
  };

  Component = () => {
    const rules = this.useValidationRules();
    const validationFunction = this.useValidationFunction();
    const options = this.#useOptions();
    const props = this.useProperties();

    return (
      <Select
        {...props}
        initialValue={this.config.initialValue}
        validationFunction={validationFunction}
        name={this.name}
        label={this.label}
        validationRules={rules}
        options={options}
      />
    );
  };
}
